import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmPromotionViewsDelegator {
	constructor() {
		this.type = GtmTrackingType.PROMO_VIEWS;
		this.dataMapper = [
			{
				dataName: 'data-promo-id',
				gtmKey: 'id',
			},
			{
				dataName: 'data-promo-name',
				gtmKey: 'name',
			},
			{
				dataName: 'data-promo-creative',
				gtmKey: 'creative',
			},
			{
				dataName: 'data-promo-position',
				gtmKey: 'position',
			},
		];
	}

	getTrackingData() {
		const selector = '[data-gtm-tracking-type="gtm_promo_click"]';
		const promos = Array.from(document.querySelectorAll(selector)).filter(
			banner =>
				banner.dataset.promoId !== '' || banner.dataset.promoName !== '',
		);

		if (promos.length) {
			return {
				event: 'promoView',
				ecommerce: {
					promoView: {
						actionField: {
							list: TrackingHelperInstance.generateActionFieldString(),
						},
						promotions: promos.map(promo =>
							TrackingHelperInstance.getRequiredDataAsObject(
								promo,
								this.dataMapper,
							),
						),
					},
				},
			};
		}
	}
}

const GtmPromotionViewsDelegatorInstance = new GtmPromotionViewsDelegator();
export default GtmPromotionViewsDelegatorInstance;

// for test purpose only
export const GtmPromotionViewsDelegatorClass = GtmPromotionViewsDelegator;
